const API_BASE = 'https://api.dev.auxo.dk';

export async function fetchCollection(collectionName) {
  try {
    const res = await fetch(`${API_BASE}/public/content/${collectionName}`);
    if (!res.ok) {
      console.warn(`Failed to fetch collection ${collectionName}: ${res.status}`);
      return [];
    }
    const data = await res.json();
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error(`Error fetching collection ${collectionName}:`, error);
    return [];
  }
}

export async function fetchCollectionV2(collectionName, params = {}) {
  try {
    const query = new URLSearchParams(params).toString();
    const url = `${API_BASE}/public/v2/content/${collectionName}${query ? `?${query}` : ''}`;
    const res = await fetch(url);
    if (!res.ok) {
      console.warn(`Failed to fetch v2 collection ${collectionName}: ${res.status}`);
      return { items: [], total: 0 };
    }
    const data = await res.json();
    return data;
  } catch (error) {
    console.error(`Error fetching v2 collection ${collectionName}:`, error);
    return { items: [], total: 0 };
  }
}

export async function fetchEntryById(collectionName, entryId) {
  try {
    const res = await fetch(`${API_BASE}/public/content/${collectionName}/${entryId}`);
    if (!res.ok) return null;
    return await res.json();
  } catch (error) {
    console.error(`Error fetching entry ${entryId}:`, error);
    return null;
  }
}
